import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { AnalyticsPlaces } from 'views/pages/User/analyticsPlaces'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { CloseDealModalContent } from 'views/components/CloseDealModal/CloseDealModalContent'

import { useAFormHandler } from 'analytics/hooks'

import { SharedModalTitle } from 'views/components/SharedModal'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { SampleWithRequests } from 'views/pages/Samples/types'

interface Props {
  onStatusChange: () => void
  onClose: () => void
  matchId: string
  samples: SampleWithRequests[]
}

export const RemoveMatchModal: FC<Props> = ({ onClose, matchId, onStatusChange, samples }) => {
  const { formProgress, formHandler } = useAFormHandler('removeMatch')
  const { t } = useTranslation('deal')

  const formik = useFormik<{ closed_reason: string; cancel_sample_request: boolean }>({
    initialValues: {
      closed_reason: '',
      cancel_sample_request: false,
    },
    onSubmit: formHandler(async () => await apiClient.post(endpoints.dealClose(matchId), formik.values), {
      onSuccess: async () => {
        await onStatusChange()
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ASharedModal id={AnalyticsPlaces.REMOVE_MATCH_MODAL} size="small" onClose={onClose}>
      <SharedModalTitle>{t('closeDealModal.title')}</SharedModalTitle>

      <CloseDealModalContent formik={formik} value="closed_reason" samplesData={samples} />

      <ADefaultModalFooter
        onConfirm={() => formik.handleSubmit()}
        confirmButtonText={t('closeDeal')}
        onClose={onClose}
        progress={formProgress}
      />
    </ASharedModal>
  )
}
